export const modalStyles: Record<string, React.CSSProperties> = {
  modalOverlayStyle: {
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    backgroundColor: 'rgba(0, 0, 0, 0.5)', // bg-black bg-opacity-50
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000, // Increased to ensure it appears above Leaflet map
  },
  modalTitleStyle: {
    fontSize: '18px', // text-lg
    fontWeight: 'bold', // font-bold
    marginBottom: '16px', // mb-4
  },
  modalContentStyle: {
    backgroundColor: '#ffffff',
    padding: '24px', // p-6
    borderRadius: '8px', // rounded-lg
    boxShadow:
      '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)', // shadow-lg
    width: '450px', // Wider to accommodate more fields
    maxHeight: '90vh', // Limit height to viewport
    overflowY: 'auto', // Add scroll for tall content
  },
  modalSaveButtonStyle: {
    padding: '8px 16px', // px-4 py-2
    backgroundColor: '#059669', // bg-green-600
    color: '#ffffff', // text-white
    borderRadius: '4px', // rounded
    marginTop: '16px', // mt-4
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    outline: 'none',
  },
  modalSaveButtonHoverStyle: {
    backgroundColor: '#047857', // hover:bg-green-700
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  },
  modalSaveButtonFocusStyle: {
    boxShadow: '0 0 0 2px #059669', // focus ring
    outline: 'none',
  },
  modalEditButtonStyle: {
    backgroundColor: '#3b82f6', // bg-blue-500 - primary action in view mode
  },
  modalEditButtonHoverStyle: {
    backgroundColor: '#2563eb', // hover:bg-blue-600
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  },
  modalDisabledButtonStyle: {
    backgroundColor: '#9ca3af', // bg-gray-400
    cursor: 'not-allowed',
    opacity: 0.6,
  },
  modalCloseButtonStyle: {
    padding: '8px 16px', // px-4 py-2
    backgroundColor: '#9ca3af', // bg-gray-400
    color: '#ffffff', // text-white
    borderRadius: '4px', // rounded
    marginTop: '16px', // mt-4
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    outline: 'none',
  },
  modalCloseButtonHoverStyle: {
    backgroundColor: '#6b7280', // hover:bg-gray-500
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  },
  modalCloseButtonFocusStyle: {
    boxShadow: '0 0 0 2px #9ca3af', // focus ring
    outline: 'none',
  },
  floatingFieldContainer: {
    position: 'relative',
    marginBottom: '16px', // TODO: Fix strange spacing here
  },
  textareaContainer: {
    position: 'relative',
    marginBottom: '16px',
  },
  floatingInputStyle: {
    width: '100%',
    padding: '12px 8px 8px 8px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '#d1d5db',
    borderRadius: '4px',
    fontSize: '16px',
    outline: 'none',
    transition: 'border-color 0.2s ease-in-out',
    backgroundColor: '#ffffff',
  },
  floatingTextareaStyle: {
    width: '100%',
    padding: '12px 8px 8px 8px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '#d1d5db',
    borderRadius: '4px',
    fontSize: '16px',
    outline: 'none',
    transition: 'border-color 0.2s ease-in-out',
    backgroundColor: '#ffffff',
    resize: 'vertical' as const,
    minHeight: '80px',
  },
  floatingLabelStyle: {
    position: 'absolute',
    left: '8px',
    top: '50%',
    transform: 'translateY(-50%)',
    fontSize: '16px',
    color: '#6b7280',
    backgroundColor: '#ffffff',
    padding: '0 4px',
    transition: 'all 0.2s ease-in-out',
    pointerEvents: 'none' as const,
    zIndex: 1,
  },
  floatingLabelFocusedStyle: {
    top: '0',
    transform: 'translateY(-50%)',
    fontSize: '12px',
    color: '#3b82f6',
    fontWeight: '500',
  },
  floatingLabelDisabledStyle: {
    color: '#9ca3af',
  },
  floatingInputFocusedStyle: {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '#3b82f6',
    boxShadow: '0 0 0 1px #3b82f6',
  },
  floatingInputDisabledStyle: {
    backgroundColor: '#f9fafb',
    color: '#6b7280',
    cursor: 'not-allowed',
  },
  // Additional styles for enhanced field components
  modalHeaderStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
    borderBottom: '1px solid #e5e7eb',
    paddingBottom: '16px',
  },
  modalBodyStyle: {
    maxHeight: '60vh',
    overflowY: 'auto' as const,
    marginBottom: '24px',
  },
  modalFooterStyle: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
    paddingTop: '16px',
    borderTop: '1px solid #e5e7eb',
  },
  modalCloseXStyle: {
    background: 'none',
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    color: '#6b7280',
    padding: '0',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '4px',
    transition: 'all 0.2s ease-in-out',
  },
  modalCloseXHoverStyle: {
    backgroundColor: '#f3f4f6',
    color: '#374151',
  },
  floatingSelectStyle: {
    width: '100%',
    padding: '12px 8px 8px 8px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '#d1d5db',
    borderRadius: '4px',
    fontSize: '16px',
    outline: 'none',
    transition: 'border-color 0.2s ease-in-out',
    backgroundColor: '#ffffff',
    cursor: 'pointer',
  },
  floatingSelectDisabledStyle: {
    backgroundColor: '#f9fafb',
    color: '#6b7280',
    cursor: 'not-allowed',
  },
  // Field validation styles
  fieldContainer: {
    margin: '8px 0 0 0',
  },
  floatingInputErrorStyle: {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '#ef4444',
    boxShadow: '0 0 0 1px #ef4444',
  },
  floatingLabelErrorStyle: {
    color: '#ef4444',
  },
  fieldErrorMessageStyle: {
    fontSize: '12px',
    color: '#ef4444',
    marginTop: '4px',
    display: 'block',
  },
  fieldHelpTextStyle: {
    fontSize: '12px',
    color: '#6b7280',
    marginTop: '4px',
    display: 'block',
  },
  noConflictsContainer: {
    backgroundColor: '#ecfdf5',
    border: '1px solid #10b981',
    borderRadius: '8px',
    padding: '16px',
    marginBottom: '16px',
  },
  noConflictsTitle: {
    color: '#065f46',
    fontWeight: '500',
  },
  noConflictsDescription: {
    color: '#6b7280',
    fontSize: '14px',
    marginTop: '8px',
  },
  conflictContainer: {
    marginBottom: '16px',
  },
  conflictTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#374151',
    marginBottom: '12px',
  },
  conflictDescription: {
    fontSize: '14px',
    color: '#6b7280',
    marginBottom: '16px',
  },
  conflictFieldContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  conflictField: {
    border: '1px solid #d1d5db',
    borderRadius: '8px',
    padding: '12px',
    backgroundColor: '#ffffff',
  },
  fieldLabel: {
    fontWeight: '600',
    fontSize: '14px',
    marginBottom: '8px',
    color: '#374151',
  },
  fieldOptionsContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '12px',
  },
  fieldOptionValue: {
    fontSize: '14px',
    color: '#374151',
    wordBreak: 'break-word',
  },
  confirmStepWarningContainer: {
    backgroundColor: '#fef2f2',
    border: '1px solid #ef4444',
    borderRadius: '4px',
    padding: '16px',
    marginBottom: '16px',
  },
  confirmStepWarningTitle: {
    marginTop: 0,
    fontSize: '14px',
    fontWeight: '600',
    color: '#991b1b',
  },
  confirmStepWarningText: {
    fontSize: '14px',
    lineHeight: '1.6',
    color: '#7f1d1d',
  },
  confirmStepChangesContainer: {
    backgroundColor: '#f9fafb',
    padding: '16px',
    borderRadius: '4px',
    marginBottom: '16px',
  },
  confirmStepChangesText: {
    fontSize: '14px',
    lineHeight: '1.8',
  },
};
